import { forwardRef, MouseEvent, PropsWithChildren, useImperativeHandle, useRef } from "react";

import { DialogHandle, DialogProps } from '../model';
import { IconNames } from '@/features/icon/model';
import { IconButton } from '@/features/ui-elements/buttons/icon-button/ui';

import cls from './styles.module.pcss';

export const Dialog = forwardRef<DialogHandle, DialogProps & PropsWithChildren>(({ children, content, withButton = true, onClose, onOpen, disableOnClickOutside }, ref) => {
  const dialogRef = useRef<HTMLDialogElement>(null);
  useImperativeHandle(ref, () => ({ open, close }));

  function open() {
    onOpen?.();
    dialogRef.current?.showModal();
  }

  function close() {
    dialogRef.current?.close();
  }

  function onCLickOutside(e: MouseEvent<HTMLElement>) {
    if (disableOnClickOutside && (e.target as HTMLElement).querySelector(`.${cls.DialogContent}`)) {
      close();
    }
  }

  return (
    <>
      <dialog className={cls.Dialog} ref={dialogRef} onClick={onCLickOutside} onClose={onClose}>
        <div className={cls.DialogContent}>
          <div className={cls.DialogClose} onClick={close}>
            <IconButton name={IconNames.CLOSE} />
          </div>
          {content}
        </div>
      </dialog>

      {withButton && (
        <div className={cls.DialogButton} onClick={open}>
          {children}
        </div>
      )}
    </>
  )
});
